var map = {
	"./gallery": 3,
	"./gallery.js": 3,
	"./header": 5,
	"./header.js": 5,
	"./modal": 6,
	"./modal.js": 6,
	"./responsive-videos": 0,
	"./responsive-videos.js": 0,
	"./slideshow": 7,
	"./slideshow.js": 7,
	"./toggler": 8,
	"./toggler.js": 8
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;


//////////////////
// WEBPACK FOOTER
// ./src/javascript/features ^\.\/.*$
// module id = 12
// module chunks = 0